<template>
  <b-dropdown-item
    :id="idDropdownItem"
    :class="`${props.className} tw-text-[#231F20]`"
    :data-cy="dataCyId"
    @click="selected = !selected"
  >
    <button
      v-if="typeof props.data.selected === 'boolean'"
      class="tw-mr-[12px] focusDrop"
    >
      <img
        v-show="selected"
        src="/img/elipse_selected_icon.svg"
        alt="eclipse_icon"
      />
      <img v-show="!selected" src="/img/elipse_icon.svg" alt="eclipse_icon" />
    </button>
    {{ props.data?.name || "" }}
  </b-dropdown-item>
</template>
<script setup lang="ts">
import { IDropDownData } from "@/interfaces/common/IDropDown";
import { PropType, ref } from "vue";

const props = defineProps({
  className: {
    type: String,
    default: "",
  },
  data: {
    type: Object as PropType<IDropDownData>,
    default: () => ({}),
  },
  dataCyId: {
    type: String,
    default: "",
  },
  idDropdownItem: {
    type: String,
    default: "",
  },
});

let selected = ref(props.data.selected);
</script>
<style lang="scss">
button {
  border: none;
  background-color: transparent;
}

.dropdown-menu {
  border-top: none;
  border-left: 1px solid #eff0f1;
  border-right: 1px solid #eff0f1;
  border-bottom: 1px solid #eff0f1;
  background-color: #fff;
  padding: 0;
  margin-top: 0;
  min-width: 100% !important;
}

.dropdown-item.normal-dropdown-container {
  padding: 18px 24px;
  font-size: 13px;
  font-weight: 400;
  border-top: 1px solid #eff0f1;
  background-color: #fff;
  box-shadow: none;
  width: 100%;
  height: 56px;
}
</style>
